import { render, staticRenderFns } from "./QTabItem.vue?vue&type=template&id=333b143b&scoped=true"
import script from "./QTabItem.vue?vue&type=script&lang=js"
export * from "./QTabItem.vue?vue&type=script&lang=js"
import style0 from "./QTabItem.vue?vue&type=style&index=0&id=333b143b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b143b",
  null
  
)

export default component.exports